import React, {useEffect, useState} from 'react';
import GetProductList from "../Products/GetProductList";
import {Form, InputNumber, Select} from "antd";
import IconBtn from "../../microComponents/elements/IconBtn";
import {FaPlus} from "react-icons/fa6";
import Pallet from "../../http_request/Model/pallet/Pallet";
import {IoMdClose} from "react-icons/io";

const ProductsOrder = ({
                           id, data, create, show, reset
                       }) => {
    const [form] = Form.useForm();

    const [productList, setProductList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [productListLoading, setProductListLoading] = useState(false);
    const [addDateArr, setAddDateArr] = useState([]);

    useEffect(() => {

        GetProductList(setProductList, setProductListLoading)


    }, []);
    useEffect(() => {

        form.resetFields()
        setAddDateArr([])


    }, [reset,form]);

    useEffect(() => {

        if (data?.length) {
            setAddDateArr(data)
        }

    }, [data]);


    const onFinish = (values) => {
        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                setAddDateArr([result, ...addDateArr])
                form.resetFields()
            }, final: () => {
                setLoading(false)
            }
        }).createOrderDetail(id, values)
    };
    const handleDelete = (index, idDetail) => {


        Pallet.request({
            beforeSend: () => {
                setLoadingDelete(true)
            }, success: (result) => {
                let arr = [...addDateArr]
                arr.splice(index, 1)
                setAddDateArr([...arr])
            }, final: () => {
                setLoadingDelete(false)
            }
        }).deleteOrderDetail(idDetail)


    }
    return (<div>{!show && <div className="flex">
        <Form
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={{}}
            autoComplete="off"
        >

            <div className="flex gap-1 items-start flex-wrap w-full">

             <div className="flex-1">
                 <Form.Item
                     name="productCode"

                     rules={[{
                         required: true, message: 'لطفا محصول را وارد کنید!',
                     },]}
                     // label='محصول'
                 >
                     <Select showSearch style={{width: '220px'}} placeholder="محصول"
                             loading={productListLoading}
                             filterOption={(input, option) => {
                                 return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                             }}
                             optionFilterProp='label'
                             options={productList}/>
                 </Form.Item>
             </div>
               <div className="flex gap-1 items-start">
                   <Form.Item
                       name="quantity" style={{width: '100px'}}
                       rules={[{
                           required: true, message: 'تعداد را وارد کنید!',
                       },]}

                   >
                       <InputNumber className='w-full' placeholder="تعداد"
                                    formatter={value => `  ${value} `.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                           // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                       />

                   </Form.Item>
                   <Form.Item
                       name="price"
                       rules={[{
                           required: true, message: 'قیمت را وارد کنید!',
                       },]}
                       style={{width: '100px'}}
                   >
                       <InputNumber className='w-full' placeholder="قیمت"
                                    formatter={value => `  ${value} `.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                           // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                       />

                   </Form.Item>
                   <Form.Item >
                       <IconBtn TooltipText='افزودن' color='blueIconBtn' loading={loading}

                                onClick={() => {
                                    form.submit()
                                }}>

                           <FaPlus/>
                       </IconBtn>


                   </Form.Item>
               </div>
            </div>
        </Form>
    </div>}


      <div className='overflow-auto'>
          {!create && <div className='w-fit '>
              <div className='flex gap-1 items-center font-bold py-3'>
                  <span className='pr-4' style={{width: '220px'}}>محصول</span>
                  <span style={{width: '100px'}}>تعداد</span>
                  <span style={{width: '100px'}}>قیمت</span>
                  <span style={{width: '100px'}}>تعداد بارگیری</span>
                  <span style={{width: '100px'}}>قیمت بارگیری</span>
                  <span style={{width: '100px'}}>کد محصول</span>
              </div>
              <hr/>
          </div>}


          {addDateArr.map((item, index) => (

              <div className='w-fit  '>


                  <div
                      className={`flex gap-1 items-center  py-3 ${item.loadedQuantity > item.quantity ? 'bg-red-200' : item.loadedQuantity < item.quantity && 'bg-yellow-100'}`}
                      key={index}>
                      <span className='pr-4' style={{width: '220px'}}>{item.productName}</span>
                      <span style={{width: '100px'}}>{item.quantity}</span>
                      <span style={{width: '100px'}}>{item.price}</span>
                      {!create && <>
                          <span style={{width: '100px'}}>{item.loadedQuantity}</span>
                          <span style={{width: '100px'}}>{item.loadedPrice}</span>
                          <span style={{width: '100px'}}>{item.productCode}</span>
                      </>}
                      {!show && <IconBtn TooltipText='حذف' color='grayIconBtn' loading={loadingDelete}

                                         onClick={() => handleDelete(index, item.id)}>
                          <IoMdClose/>
                      </IconBtn>}

                  </div>
                  <hr/>
              </div>


          ))}
      </div>
    </div>);
};

export default ProductsOrder;